// frontend/src/lib/contactGroups.js — 2026-09-16
//
// Frontend mirror of api/src/lib/contactGroups.js.
//
// That backend module calls itself the single source of truth for
// contacts.contact_group and states "direct string comparison against local
// arrays is forbidden".  It could only ever be single on the backend: it is
// CommonJS under api/src/, which CRA cannot import from frontend/src.  So four
// frontend files each kept their own hand-copied literal and all four drifted —
// two of them so badly that POST /api/contacts rejected every option they
// offered.  This file is the one place the frontend may get these values from.
//
// MUST STAY IN LOCKSTEP WITH api/src/lib/contactGroups.js — same values, same
// order.  That is not a request: api/src/tests/contactGroupsParity.test.js
// reads both files and fails on any divergence, including a reordering, a
// missing label, and a missing colour.  Follows the Ship 7g precedent of
// frontend/src/lib/invoiceTemplates.js.
//
// Colours are Tailwind class pairs consumed directly in className.  The ten
// pre-existing values carry the exact strings Contacts.js used before this
// file existed, so no chip changed appearance.  'witness' (Ship 7i) is the
// only new one — amber, deliberately distinct from expert_witness purple so a
// fact witness and a retained expert never read alike at a glance.

export const CONTACT_GROUPS = Object.freeze([
  { value: 'client',           label: 'Client',           color: 'bg-blue-100 text-blue-700' },
  { value: 'opposing_counsel', label: 'Opposing Counsel', color: 'bg-red-100 text-red-700' },
  { value: 'co_counsel',       label: 'Co-Counsel',       color: 'bg-green-100 text-green-700' },
  { value: 'expert_witness',   label: 'Expert Witness',   color: 'bg-purple-100 text-purple-700' },
  { value: 'witness',          label: 'Witness',          color: 'bg-amber-100 text-amber-700' },
  { value: 'mediator',         label: 'Mediator',         color: 'bg-yellow-100 text-yellow-700' },
  { value: 'judge',            label: 'Judge',            color: 'bg-indigo-100 text-indigo-700' },
  { value: 'court_reporter',   label: 'Court Reporter',   color: 'bg-pink-100 text-pink-700' },
  { value: 'process_server',   label: 'Process Server',   color: 'bg-orange-100 text-orange-700' },
  { value: 'attorney',         label: 'Attorney',         color: 'bg-teal-100 text-teal-700' },
  { value: 'other',            label: 'Other',            color: 'bg-gray-100 text-gray-700' },
])

const DEFAULT_COLOR = 'bg-gray-100 text-gray-700'

// Human label for a stored enum value.  Falls back to the raw value so an
// unrecognised group is visible rather than blank.
export function groupLabel (val) {
  return CONTACT_GROUPS.find(g => g.value === val)?.label || val
}

// Tailwind chip classes for a stored enum value.
export function groupColor (val) {
  return CONTACT_GROUPS.find(g => g.value === val)?.color || DEFAULT_COLOR
}

export function isValidContactGroup (val) {
  return typeof val === 'string' && CONTACT_GROUPS.some(g => g.value === val)
}
